import * as React from 'react';

type IconSecureProps = React.SVGProps<SVGSVGElement>;

export const IconSecure: React.FC<IconSecureProps> = (props) => (
	<svg
		width={15}
		height={16}
		viewBox="0 0 15 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M7.49689 0C7.64064 0 7.78439 0.03125 7.91564 0.090625L13.8031 2.5875C14.4906 2.87813 15.0031 3.55625 15 4.375C14.9844 7.475 13.7094 13.1469 8.32501 15.725C7.80314 15.975 7.19689 15.975 6.67501 15.725C1.28751 13.1469 0.0156392 7.475 1.4214e-05 4.375C-0.00311079 3.55625 0.509389 2.87813 1.19689 2.5875L7.08126 0.090625C7.21251 0.03125 7.35314 0 7.49689 0ZM7.49689 2.0875V13.9031C11.8094 11.8156 12.9688 7.19063 12.9969 4.42188L7.49689 2.09062V2.0875Z"
			fill="#D4D8DB"
		/>
	</svg>
);
